module.exports = {
    frontServerURL: process.env.FRONT_SERVER_URL,
    frontServerTimeout: parseInt(process.env.FRONT_SERVER_TIMEOUT) || 2000,
    dataServerURL: process.env.DATA_SERVER_URL,
    dataServerTimeout: parseInt(process.env.DATA_SERVER_TIMEOUT) || 10000,
    dataServerToken: process.env.DATA_SERVER_TOKEN,
    brandName: process.env.BRAND_NAME,
};